import React from 'react';

export class DonationBreadcrumb extends React.Component {

  render(){
    return(
      <div className="wrapper rounded row">
        <div className="col-md-4 breadcrumb-col">
          <div className={"col-md-12 rounded"+(this.props.active===1?" active":"")}>
            Billing Info
          </div>
        </div>
        <div className="col-md-4 breadcrumb-col">
          <div className={"col-md-12 rounded"+(this.props.active===2?" active":"")}>
            Payment
          </div>
        </div>
        <div className="col-md-4 breadcrumb-col">
          <div className={"col-md-12 rounded"+(this.props.active===3?" active":"")}>
            Confirmation
          </div>
        </div>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/DonationBreadcrumb.js